export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'gold' | 'navy'
export type BadgeSize = 'sm' | 'md'

interface Props {
  label: string
  variant?: BadgeVariant
  size?: BadgeSize
  icon?: string
}

export function Badge({ label, variant = 'default', size = 'md', icon }: Props) {
  return (
    <span className={`cf-badge cf-badge--${variant} cf-badge--${size}`}>
      {icon && <span aria-hidden>{icon}</span>}
      {label}
    </span>
  )
}
